import {Transforms} from "../../../../../../pkg/slate.js";
export const insertEmptyElement = (editor, type, options) => {
  const node = {type, children: [{text: ""}]};
  Transforms.insertNodes(editor, node, options);
};
